export default "__VITE_ASSET__D2pCxB9a__"